import { isAuthenticated } from "../../../commons/Auth/auth";
import { hasPermission } from "../../../commons/Permissions/PermissionsHook";

/**
 * Whether the signed-in user may use site documentation in the service-provider panel: the
 * provider, or an employee whose role may document ("Site-docs" Create) or read it. The server
 * checks again; this only decides whether to show the entry points (also on pages customers
 * share, such as /invoices/details/:id).
 */
export const canUseSiteDocs = () => {
  const user = isAuthenticated();
  if (![1, 2].includes(Number(user?.role))) return false;
  const permissions = user?.roleId?.permissions;
  return (
    hasPermission(permissions, "Site-docs", "Read") ||
    hasPermission(permissions, "Site-docs", "Create")
  );
};
